
import api from '../axios/api'
var moment = require('moment');
export default {
    install(Vue, options) {
        /* neakasa app 语言、产品 */
        Vue.prototype.appData = {
            lang: {
                zh: '中文',
                tw: '中文（繁体）',
                en: '英文',
                jp: '日文',
                ko: '韩文',
                de: '德文',
                fr: '法文',
                ru: '俄文',
                tr: '土耳其文',
                it: '意大利文',
                es: '西班牙文',
                pl: '波兰语',
            },
            product: ['M1', 'A1P', 'T80', 'Q11', 'F1', 'P0', 'P1', 'P2', 'S1', 'N1P', 'N2', 'N2Lite', 'N3']
            // product: ['M1', 'A1P', 'T80', 'Q11', 'F1', 'Riko', 'P0', 'P1', 'P2', 'S1', 'N1P', 'N2', 'N2Lite', 'N3']
        }
        /* 服务器时间戳(格林威治时间)转当前日期 */
        Vue.prototype.timezone = -((new Date()).getTimezoneOffset() / 60);
        Vue.prototype.formDate = function (d, format) { //时间戳转时间 
            if (!d) {
                return '';
            }
            let timer = d;
            timer = timer > 10000000000 ? timer : timer + '000';
            return moment(parseInt(timer)).format(format ? format : 'YYYY-MM-DD HH:mm:ss');
        }
        Vue.prototype.setDate = function(day, disabledToday) {
            const date = new Date();
            //结束时间为23:59:59
            let end = date.getTime() + ((24 - date.getHours())  * 3600 - date.getMinutes() * 60 - date.getSeconds() - 1) * 1000  - date.getMilliseconds();
            if(disabledToday) { //禁止选择今天
                end -= 86400000;
            }
            //开始时间为00:00:00
            const start = end - 3600 * 1000 * 24 * day + 1000;
            return [start, end];
        },
        /* form rule */
        Vue.prototype.requiredRule = function (msg, trigger, type) {
            let rule = { 
                required: true, 
                message: msg, 
            };
            return rule;
        }
        /* 更新用户信息 */
        Vue.prototype.getUserInfo = function () {
            this.api.getUserInfo({}).then(data => {
                localStorage.setItem('userInfo', JSON.stringify(data.data));
                this.$store.commit('updateUserInfo', data.data);
            })
        }
        /*  格式化数字，3位数一个逗号 */
        Vue.prototype.formatNumber = function (n) {
            n += '';
            n = n.split('.');
            let num = parseFloat(n[0]).toLocaleString();
            if (n[1] && n[1] != 0) {
                num += ('.' + n[1]);
            }
            return num;
        }
        /*********确认弹窗**********/
        Vue.prototype.msgConfirm = function (msg, callback, title, type) {
            this.$confirm(msg, (title ? title : '删除提示'), {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: type ? type : 'error'
            }).then(({ value }) => {
                callback(value);
            }).catch(() => {

            })
        }

        /*  权限校验 */
        Vue.prototype.roleCheck = function (key) {
            if (this.$store.state.userInfo.role && (this.$store.state.userInfo.role.indexOf('系统管理员') != -1 || this.$store.state.userInfo.permission.indexOf(key) != -1)) {
                return true;
            } else {
                return false;
            }

        }

        // 脱敏显示
        Vue.prototype.encrypt = function (field, before, after) {
            if (!field) { return ''; }
            field = String(field);
            const regItem = '[\u4e00-\u9fa5a-zA-Z0-9]';
            const regExp = `(${regItem}{${before}})${regItem}*(${regItem}{${after}})`;
            const reg = new RegExp(regExp);
            return field.replace(reg, '$1*****$2');
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/common.js